<template>
  <div class="desc" v-if="descData" :class="[descClass, descVisibilityClass]">
    <div class="desc__visibility"
         v-observe-visibility="descVisibility">

    </div>
    <div class="desc__inner cia-container">
      <div class="desc__text">
        <h2 class="animation-item animation-item--duration1 animation-top">{{descData.header}}</h2>
        <p class="animation-item animation-item--duration2 animation-top">{{descData.desc}} </p>
      </div>
      <div class="desc__photo animation-item animation-top">
        <img :src="require(`@/assets/${descData.image}`)" :alt="descData.header"/>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'cia-desc',
  data: () => ({
    isDescVisible: false,
  }),
  props: ['descData'],
  computed: {
    descVisibilityClass() {
      return this.isDescVisible ? 'on' : 'off';
    },
    descClass() {
      return `desc--${this.descData.align}`;
    },
  },
  methods: {
    descVisibility(isVisible) {
      this.isDescVisible = isVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
  .desc {
    position: relative;
    background: #fff;
    padding-bottom: 60px;
    @media (min-width: 550px) {
      padding-bottom: 60px;
    }
    @media (min-width: 1260px) {
      padding-bottom: 120px;
    }
    &__visibility {
      pointer-events: none;
      left: 0;
      right: 0;
      position: absolute;
      top: 30%;
      height: 80%;
    }
    &__inner {
      display: flex;
      align-items: center;
      flex-direction: column;
      @media (min-width: 900px) {
        flex-direction: row;
      }
    }
    &__photo {
      order: 1;
      flex: 0 0 50%;
      min-width: 50%;
      @media (min-width: 1260px) {
        min-width: 0;
      }
      img {
        display: block;
        width: 240px;
        margin: 0 auto;
        @media (min-width: 550px) {
          width: 300px;
        }
        @media (min-width: 900px) {
          width: auto;
          margin: 0;
          max-width: 100%;
        }
        @media (min-width: 1400px) {
          max-width: none;
        }
      }
    }
    &__text {
      padding-bottom: 30px;
      @media (min-width: 550px) {
        padding-bottom: 60px;
      }
      @media (min-width: 900px) {
        padding-bottom: 0;
        order: 2;
        margin-left: 80px;
      }
      @media (min-width: 1260px) {
        min-width: 0;
        max-width: 400px;
      }
    }
    &--right {
      .desc {
        &__photo {
          order: 2;
        }
        &__text {
          order: 1;
          margin: 0;
          @media (min-width: 900px) {
            margin: 0 90px 0 0;
          }
          @media (min-width: 1260px) {
            margin: 0 90px 0 110px;
          }
        }
      }
    }
    h2 {
      font-weight: 300;
      position: relative;
      font-size: 26px;
      padding-bottom: 20px;
      margin-bottom: 20px;
      @media (min-width: 550px) {
        font-size: 30px;
        padding-bottom: 30px;
        margin-bottom: 30px;
      }
      @media (min-width: 1000px) {
        font-size: 44px;
        padding-bottom: 40px;
      }
      &:after {
        position: absolute;
        content: '';
        background: #1976d2;
        height: 2px;
        left: 0;
        bottom: 0;
        width: 30px;
        @media (min-width: 550px) {
          width: 52px;
        }
      }
    }
    p {
      font-weight: 300;
      font-size: 14px;
      @media (min-width: 550px) {
        font-size: 16px;
      }
    }
  }
</style>
